import { Component, OnInit } from '@angular/core';
import { VariablesGlobales } from '../services/globals';
import { EventManager } from '@angular/platform-browser';

@Component({
  selector: 'app-back-profil',
  templateUrl: './back-profil.component.html',
  styleUrls: ['./back-profil.component.css']
})
export class BackProfilComponent implements OnInit {

  public isMobile = false;
  previousUrl: string;

  constructor(private eventManager: EventManager, public param: VariablesGlobales) {
    this.eventManager.addGlobalEventListener('window', 'resize', this.OnResize.bind(this));
  }

  private OnResize(event: any) {
    if (window.screen.width >= 1555) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
    //this.mapComponent.resize();
  }

  ngAfterViewChecked() {
    if (window.screen.width >= 1555) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }

  ngOnInit(): void {

  }

}
